<template>
  <div :class="geistFontClasses" class="app-wrapper">
    <div class="bg-noise"></div>
    <div class="ambient-glow glow-1"></div>
    <div class="ambient-glow glow-2"></div>

    <HeaderComponent />
    <main>
      <RouterView @vue:mounted="initReveal" />
    </main>
    <FooterComponent class="reveal" />
  </div>
</template>

<script>
import { RouterView } from 'vue-router';
import HeaderComponent from './components/HeaderComponent.vue';
import FooterComponent from './components/FooterComponent.vue';
import '@/assets/theme/styles.css';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    RouterView,
  },
  methods: {
    initReveal() {
      // Small delay to ensure the DOM is fully painted
      setTimeout(() => {
        const observerOptions = {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px', // Triggers slightly before the element hits the viewport
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('active');
              // Once it's revealed, we don't need to observe it anymore
              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach((el) => observer.observe(el));
      }, 100);
    },
  },
  mounted() {
    this.initReveal();
  },
};
</script>

<style>
/* --- 1. Global Polish --- */
html {
  scroll-behavior: smooth;
  background-color: #f2eee0;
}

.app-wrapper {
  position: relative;
  overflow-x: hidden;
  min-height: 100vh;
}

/* --- 2. Selection Styling --- */
::selection {
  background: #f5e5b0;
  color: #1a1a1a;
}

/* --- 3. Noise & Glows --- */
.bg-noise {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://www.transparenttextures.com/patterns/stardust.png');
  opacity: 0.05;
  pointer-events: none;
  z-index: 9999;
  mix-blend-mode: overlay;
}

.ambient-glow {
  position: fixed;
  width: 70vw;
  height: 70vw;
  border-radius: 50%;
  filter: blur(100px);
  z-index: -1;
  pointer-events: none;
  opacity: 0.5; /* Increased opacity so you can see it better */
}

.glow-1 {
  background: radial-gradient(circle, #faefca 0%, transparent 70%);
  top: -20%;
  left: -20%;
  animation: float 25s infinite alternate ease-in-out;
}

.glow-2 {
  background: radial-gradient(circle, #f5e5b0 0%, transparent 70%);
  bottom: -20%;
  right: -20%;
  animation: float 30s infinite alternate-reverse ease-in-out;
}

@keyframes float {
  0% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(5%, 5%) scale(1.05);
  }
  100% {
    transform: translate(-2%, 8%) scale(0.95);
  }
}

/* --- 4. SCROLL REVEAL ANIMATION --- */
/* Add the 'reveal' class to any element you want to animate */
.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 1s cubic-bezier(0.215, 0.61, 0.355, 1),
    transform 1.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  will-change: transform, opacity;
}

/* This is applied by the Javascript when you scroll */
.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

/* Staggered delays for grids/lists */
.delay-1 {
  transition-delay: 0.1s;
}
.delay-2 {
  transition-delay: 0.2s;
}
.delay-3 {
  transition-delay: 0.3s;
}

/* --- 5. Typography Fixes --- */
h1,
h2,
h3 {
  letter-spacing: -0.03em;
  font-weight: 800;
}
</style>
